
import { useEffect } from "react";

interface UseUppdragPageEffectsProps {
  user: any;
  initialLoadComplete: boolean;
  routeProjectId?: string;
  routeFolderId?: string;
  selectedFolderId: string | null;
  projectId: string | null;
  fetchDefaultProject: () => void;
  handleSelectFolder: (folderId: string) => void;
  setActiveTab: (tab: string) => void;
}

export const useUppdragPageEffects = ({
  user,
  initialLoadComplete,
  routeProjectId,
  routeFolderId,
  selectedFolderId,
  projectId,
  fetchDefaultProject,
  handleSelectFolder,
  setActiveTab
}: UseUppdragPageEffectsProps) => {
  // Initial load effect - run once when initial load not complete and no route params
  useEffect(() => {
    if (!initialLoadComplete && !routeProjectId && !routeFolderId) {
      console.log("Initial load: attempting to fetch default project...");
      fetchDefaultProject();
    }
  }, [initialLoadComplete, routeProjectId, routeFolderId, fetchDefaultProject]);

  // Handle route-based folder selection - only after initial load is complete
  useEffect(() => {
    if (routeFolderId && !selectedFolderId && initialLoadComplete) {
      console.log("Selecting folder from route:", routeFolderId);
      handleSelectFolder(routeFolderId);
    }
  }, [routeFolderId, selectedFolderId, initialLoadComplete, handleSelectFolder]);

  // Set active tab to projects when no project is selected
  useEffect(() => {
    if (!projectId && !selectedFolderId && initialLoadComplete) {
      console.log("No project selected, setting active tab to projects");
      setActiveTab("projects");
    }
  }, [projectId, selectedFolderId, initialLoadComplete, setActiveTab]);
};
